import dayjs from 'dayjs'
import duration from 'dayjs/plugin/duration'
import relativeTime from 'dayjs/plugin/relativeTime'

dayjs.extend(duration)
dayjs.extend(relativeTime)

export const formatDateTime = (value?: string | null) =>
  value ? dayjs(value).format('DD MMM YYYY HH:mm:ss') : '—'

export const formatDate = (value?: string | null) =>
  value ? dayjs(value).format('DD MMM YYYY') : '—'

export const formatDuration = (ms?: number | null) => {
  if (ms == null) {
    return '—'
  }
  const d = dayjs.duration(ms)
  if (d.asHours() >= 1) {
    return `${Math.floor(d.asHours())}h ${d.minutes()}m`
  }
  if (d.asMinutes() >= 1) {
    return `${d.minutes()}m ${d.seconds()}s`
  }
  return `${d.seconds()}s`
}

export const formatRelative = (value?: string | null) => (value ? dayjs(value).fromNow() : '—')
